import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useAuthHeader, useAuthUser } from 'react-auth-kit';
import User from '../../Models/User';
import datas from "../../Assets/data.json";
import EditNumCaisse from './EditNumCaisse';
import NewCaisse from './NewCaisse';
import FormUpdateCaisse from './FormUpdateCaisse';
import env from 'react-dotenv';
import { Crypter } from '../../Functions/Security/Crypter';
import { useAlert, Spin, DataTable, Badge, ImagePreview, SearchInput } from '../ui';
import { DataTableColumn } from '../ui/DataTable';
import TableStatusBar from '../ui/TableStatusBar';
import InfoBar from '../ui/InfoBar';
import PageHeader from '../ui/PageHeader';


export default function ManageCaisse() {
    // USER SESSION
    const auth = useAuthUser()
    const user: User = JSON.parse(JSON.stringify(auth() || {}))

    // USER TOKEN
    const authHeader = useAuthHeader()
    const alert = useAlert();

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [data, setData] = useState([])

    const [arrierePlan, setArrierePlan] = useState([])
    const [arrierePlanSelected, setArrierePlanSelected] = useState<any>()

    const [dataTri, setDataTri] = useState<any>([])

    const [loading, selLoading] = useState(false)
    const [textRes, setTextRes] = useState("")

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    useEffect(() => {
        LoadData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function Search(search: string) {
        if (search.length == 0) {
            LoadData()
        }
        else {
            selLoading(true)
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: env.API_BASE_URL + datas.API_LINKs.GetFilialeBy + Crypter.encrypt(search),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': authHeader(),
                }
            };
            console.log(Crypter.encrypt(search))

            axios.request(config)
                .then((response: any) => {
                    const res = JSON.parse(Crypter.decrypt(response.data)).Value
                    if (res.StatutCode == 200) {
                        selLoading(false)

                        const users: any = []
                        const ap: any = []

                        res.Result.map((data: any) => {
                            if (data.Statut != 2) {
                                users.push({ id: data.CodeU, CodeU: data.CodeU, Image: data.Image, Name: data.Name, Prenom: data.Prenom, Mobile: data.Mobile, Service: data.CodeS, Statut: data.Statut, Actions: data.CodeU, Email: data.Email, CodeFiliale: data.CodeFiliale }
                                )
                                ap.push({ id: data.CodeU, ModifDate: data.ModifDate, UpdateCount: data.UpdateCount, CreatedBy: data.CreatedBy, ExpiredSession: data.ExpiredSession, ExpiredDate: data.ExpiredDate })
                            }
                        })

                        setDataTri(users)
                        setArrierePlan(ap)


                    }
                    else {
                        selLoading(false)
                        setDataTri([])
                        setTextRes("")
                        alert.warning(res.Message)
                    }
                })
                .catch((error: any) => {
                    setTextRes("")
                    alert.error('Error', error)
                    selLoading(false)
                    console.log(error);
                });
        }

    }
    function LoadData() {
        const codeAbonne = user.CodeAbonne
        selLoading(true)
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: env.API_BASE_URL + datas.API_LINKs.Operationnels + Crypter.encrypt(codeAbonne),
            headers: {
                'Accept': 'text/plain',
                'Authorization': authHeader(),
            }
        };

        axios.request(config)
            .then((response: any) => {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value
                if (res.StatutCode == 200) {
                    selLoading(false)

                    const users: any = []
                    const ap: any = []

                    res.Result.map((data: any) => {
                        if (data.Statut != 2) {
                            users.push({ id: data.CodeU, CodeU: data.CodeU, Image: data.Image, Name: data.Name, Prenom: data.Prenom, Mobile: data.Mobile, RoleId: data.RoleId, CodeS: data.CodeS, DateCreated: data.DateCreated, Statut: data.Statut, Actions: data.CodeU, Email: data.Email, CodeFiliale: data.CodeFiliale, Tvalidated: data.Tvalidated, TRejected: data.TRejected, TTransfert: data.TTransfert, NumBox: data.NumBox }
                            )
                            ap.push({ id: data.CodeU, ModifDate: data.ModifDate, UpdateCount: data.UpdateCount, CreatedBy: data.CreatedBy, ExpiredSession: data.ExpiredSession, ExpiredDate: data.ExpiredDate })
                        }
                    })

                    setDataTri(users)
                    setArrierePlan(ap)


                }
                else {
                    selLoading(false)
                    setDataTri([])
                    //localStorage.setItem("tabGuichet", JSON.stringify([]))
                    setTextRes("")
                    alert.warning(res.Message)
                }
            })
            .catch((error: any) => {
                setTextRes("")
                alert.error('Error', error)
                selLoading(false)
                console.log(error);
            });
    }

    function tri(type: string) {

        var dte: any[] = []
        if (type == "a") {
            dte = data
        } else {
            data.map((el: any) => {
                if (el.Statut == type) {
                    dte.push(el)
                }
            })

        }
        setDataTri(dte)

        setTextRes(dte.length + " Resultat(s) obtenu")

    }
    const columns: DataTableColumn[] =
        [
            {
                field: 'Image', headerName: 'Photo de Profile', width: 70, sortable: false, renderCell: (record) => (
                    <div className="flex items-center">
                        <ImagePreview
                            className="rounded-md"
                            width={40}
                            height={40}
                            src={record.value}
                        />
                    </div>
                ),
            },
            { field: 'CodeU', headerName: 'Code utilisateur', width: 100 },
            { field: 'Name', headerName: 'Nom', width: 150 },
            { field: 'Prenom', headerName: 'Prénom', width: 150 },

            { field: 'NumBox', headerName: 'Numero Box', width: 150 },

            { field: 'Tvalidated', headerName: 'Nb tickets validés', width: 150 },
            { field: 'TRejected', headerName: 'Nb tickets rejettés', width: 150 },
            { field: 'TTransfert', headerName: 'Nb tickets transférés', width: 150 },

            { field: 'Mobile', headerName: 'Tel', width: 100 },
            { field: 'RoleId', headerName: 'Groupe', width: 150 },
            { field: 'CodeFiliale', headerName: 'Filiale', width: 150 },
            { field: 'CodeS', headerName: 'Service', width: 150 },
            { field: 'DateCreated', headerName: 'Date création', width: 150 },
            { field: 'Email', headerName: 'Email', width: 150 },
            {
                field: 'Statut', headerName: 'Statut', width: 70, renderCell: (record) => (
                    <Badge color={record.value == 1 ? "blue" : record.value == 3 ? "amber" : "red"}>
                        {record.value == 1 ? "actif" : record.value == 3 ? "Nouveu" : "bloqué"}
                    </Badge>
                ),
            }
            ,
            {
                field: 'Actions', headerName: 'Actions', width: 150, sortable: false,
                renderCell: (record) => (
                    <div className="flex items-center gap-2">
                        <EditNumCaisse handleFunction={() => { LoadData() }} reccord={dataTri.find((ar: any) => (ar.id == record.value))} />
                    </div>
                ),
            },
        ];

    function handleRowClick(e: any) {
        setArrierePlanSelected(arrierePlan.find((ar: any) => (ar.id == e.id)))
    }

    const [open, setOpen] = useState(false)
    const [users, setUsers] = useState<any>()

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Spin spinning={loading} >
            <PageHeader
                title="Gestion des caisses"
                subtitle="Affectez les numéros de box et suivez les opérationnels"
            />
            <div className="eb-table-wrap">
                <SearchInput onSearch={Search} size='lg' className="mb-3" placeholder='Saisissez pour effectuer une recherche profonde' />
                <DataTable rows={dataTri} columns={columns} height={300} searchable onRowClick={handleRowClick} />
            </div>
            <TableStatusBar count={dataTri.length} loading={loading} onRefresh={LoadData} />
            <InfoBar data={[
                { label: 'Date Modif', value: arrierePlanSelected?.ModifDate },
                { label: 'Nombre de Modif', value: arrierePlanSelected?.UpdateCount },
                { label: 'Créé par', value: arrierePlanSelected?.CreatedBy },
                { label: 'ExpiredDate', value: arrierePlanSelected?.ExpiredDate },
                { label: 'Session expirée', value: arrierePlanSelected?.ExpiredSession == 1 ? 'Oui' : 'Non' },
            ]} />
        </Spin>
    );
}
